import { StrictMode } from 'react';
import { /*ReactDOM,*/ createRoot } from 'react-dom/client';
import './i18n';
import { BrowserRouter } from 'react-router';

import { initAnalytics } from '@/analytics';

// Off unless this build was given a domain that matches where it is served
// from — see `src/analytics/config.ts` (GIFTWEB-33).
initAnalytics();

import TsqProvider from './tsq/index.tsx';
import HydrationGuard from '@/components/zustand/HydrateGuard/HydrateGuard.tsx';
import ErrorBoundary from '@/wrappers/ErrorBoundary.tsx';
import App from './App.tsx';

import './index.css';
import {
  checkStorage,
  checkStorageQuota,
} from './utils/helpers/storage.helpers.ts';
import StorageUnavailableScreen from './components/StorageUnavailableScreen/StorageUnavailableScreen.tsx';

const [storageAvailable, hasQuota] = await Promise.all([
  checkStorage(),
  checkStorageQuota(),
]);

// if (process.env.NODE_ENV !== 'production') {
//   const axe = import('@axe-core/react').then((module) => module.default);
//   axe(React, ReactDOM, 1000);
// }

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <TsqProvider>
          {!storageAvailable ? (
            <StorageUnavailableScreen />
          ) : (
            <HydrationGuard hasQuota={hasQuota}>
              <App />
            </HydrationGuard>
          )}
        </TsqProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
